import React from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './Footer_2.module.css'
import logo from '../assets/Footer_Assests_Jungle_Morals/2x/logo.png'
import linkedin from '../assets/Footer_Assests_Jungle_Morals/2x/linkedin.png'
import youtube from '../assets/Footer_Assests_Jungle_Morals/2x/youtube.png'
import facebook from '../assets/Footer_Assests_Jungle_Morals/2x/facebook.png'
import instagram from '../assets/Footer_Assests_Jungle_Morals/2x/instagram.png'
import pinterest from '../assets/Footer_Assests_Jungle_Morals/2x/pinterest.png'
import board from '../assets/Footer_Assests_Jungle_Morals/2x/board.png'
import privacyPolicy from '../assets/pdf/JMWPrivacyPolicy.pdf'
import ChildrensPrivacyPolicy from '../assets/pdf/JMWChildrenPrivacyPolicy.pdf'
import CookiePolicy from '../assets/pdf/JMcookiepolicy.pdf'
import TermsandConditions from '../assets/pdf/JMWTermsandConditions.pdf'
import Disclaimer from '../assets/pdf/JMWDisclaimer.pdf'
import { Link } from 'react-router-dom'

function Footer_2() {
  const navigate = useNavigate();
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Left Section - Order 1 on Mobile, Column 1 on Desktop */}
        <div className={styles.leftSection}>
          <img src={logo} alt="Jungle Morals Logo" className={styles.logo} />

          <div className={styles.socialIcons}>
            <a href="https://www.linkedin.com/company/jungle-morals-entertainment/?viewAsMember=true" target="_blank"
              rel="noopener noreferrer" className={styles.socialLink} aria-label="LinkedIn">
              <img src={linkedin} alt="LinkedIn" />
            </a>
            <a href="https://www.youtube.com/channel/UCF4P0048BiT04m1ss61qpGA" target="_blank"
              rel="noopener noreferrer" className={styles.socialLink} aria-label="YouTube">
              <img src={youtube} alt="YouTube" />
            </a>
            <a href="https://www.facebook.com/junglemorals/" target="_blank"
              rel="noopener noreferrer" className={styles.socialLink} aria-label="Facebook">
              <img src={facebook} alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/junglemorals/" target="_blank"
              rel="noopener noreferrer" className={styles.socialLink} aria-label="Instagram">
              <img src={instagram} alt="Instagram" />
            </a>
            <a href="https://in.pinterest.com/junglemorals/" target="_blank"
              rel="noopener noreferrer" className={styles.socialLink} aria-label="Pinterest">
              <img src={pinterest} alt="Pinterest" />
            </a>
          </div>

          {/* Desktop Only - Copyright Text */}
          <p className={`font-adventuring ${styles.copyright} ${styles.desktopOnly}`}>
            All Jungle Morals characters,<br /> stories, music and related <br /> materials are original creations <br /> and are protected under applicable copyright laws.
          </p>

          <p className={`font-adventuring ${styles.companyInfo} ${styles.desktopOnly}`}>
            Jungle Morals® is a product of <br /> Jungle Morals Entertainment <br /> Pvt. Ltd.
          </p>
        </div>

        {/* Middle Section - Column 1 - Order 3 on Mobile, Column 2 on Desktop */}
        <div className={styles.middleColumn}>
          <ul className={`font-adventuring ${styles.linkList}`}>
            <Link to="/" className={styles.aa}>Home</Link>
            <Link to="/characters" className={styles.aa}>Characters</Link>
            <Link to="/whatwedo" className={styles.aa}>What We Do</Link>
            <Link to="/thewhy" className={styles.aa}>The Why</Link>
            <Link to="/about" className={styles.aa}>About</Link>
            <Link to="/blogs" className={styles.aa}>Blog</Link>

            {/* Mobile Only - Contact Us Link */}
            <li className={styles.mobileOnly}>
              <a href="mailto:contact@junglemorals.com">Contact Us</a>
            </li>
          </ul>
        </div>

        {/* Middle Section - Column 2 - Order 4 on Mobile, Column 3 on Desktop */}
        <div className={`font-adventuring ${styles.middleColumn}`}>
          <ul className={styles.linkListt}>
            <li><a href={privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
            <li><a href={ChildrensPrivacyPolicy} target="_blank" rel='noopener noreferrer'>Children's Privacy Policy</a></li>
            <li><a href={CookiePolicy} target="_blank" rel='noopener noreferrer'>Cookie Policy</a></li>
            <li><a href={TermsandConditions} target='_blank' rel='noopener noreferrer'>Terms and Conditions</a></li>
            <li><a href={Disclaimer} target='_blank' rel='noopener noreferrer'>Disclaimer</a></li>
          </ul>
        </div>

        {/* Right Section - Order 2 on Mobile, Column 4 on Desktop */}
        <div className={styles.rightSection}>
          <div className={styles.contactBox}>
            <p 
              className={`font-adventuring ${styles.contactLabel}`}
              onClick={() => navigate('/form')}
              style={{ cursor: 'pointer' }}
            >
              Grab your free <br /> activity card
            </p>
            <img src={board} alt="board" className={styles.board} 
            onClick={() => navigate('/form')} />
          </div>

          {/* Desktop Only - Contact Info */}
          <div className={`${styles.contactInfo} ${styles.desktopOnly}`}>
            <h4 className={`font-adventuring ${styles.contactTitle}`}>Contact Us</h4>
            <a href="mailto:contact@junglemorals.com" className={`font-adventuring ${styles.contactEmail}`}>
              contact@junglemorals.com
            </a>
          </div>
        </div>

        {/* Mobile Only - Copyright Text Section at Bottom - Order 5 */}
        <div className={`${styles.mobileCopyrightSection} ${styles.mobileOnly}`}>
          <p className={`font-adventuring ${styles.mobileCopyrightText}`}>
            All Jungle Morals characters, stories, music and related materials are original creations and are protected under applicable copyright laws.
          </p>

          <p className={`font-adventuring ${styles.mobileCompanyText}`}>
            Jungle Morals® is a product of Jungle Morals Entertainment Pvt. Ltd.
          </p>
        </div>
      </div>

      {/* Bottom Copyright - Order 6 on Mobile */}
      <div className={`font-adventuring ${styles.bottomBar}`}>
        <p>© 2025 Jungle Morals Entertainment Pvt. Ltd. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer_2